import { render, staticRenderFns } from "./SdScale.vue?vue&type=template&id=20427f5e&scoped=true"
import script from "./SdScale.vue?vue&type=script&lang=js"
export * from "./SdScale.vue?vue&type=script&lang=js"
import style0 from "./SdScale.vue?vue&type=style&index=0&id=20427f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20427f5e",
  null
  
)

export default component.exports